import { render, staticRenderFns } from "./CreatorsSliderItem.vue?vue&type=template&id=4d06a898&scoped=true&"
import script from "./CreatorsSliderItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorsSliderItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsSliderItem.vue?vue&type=style&index=0&id=4d06a898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06a898",
  null
  
)

export default component.exports